<template>
  <div class="bg-white rounded-3xl max-md:rounded-2xl p-5 max-md:p-3">
    <h2 class="text-txprimary font-medium text-lg max-md:text-base leading-tight">
      Размещение рекламы через Telepost
    </h2>
    <p class="text-xs text-txprimary/60 leading-normal mt-2">Частые вопросы и ответы</p>

    <div class="mt-4 flex flex-col gap-[7px]">
      <div
        v-for="(item, index) in faq"
        :key="index"
        class="rounded-xl cursor-pointer transition-colors"
        :class="openedIndex === index ? 'bg-white border border-[#D9E5FF] p-[11px]' : 'bg-bgnew p-3'"
        @click="openedIndex = openedIndex === index ? null : index"
      >
        <div class="flex items-center justify-between gap-3">
          <span class="text-sm max-md:text-xs font-medium text-txprimary leading-tight">
            {{ item.question }}
          </span>
          <Icon
            name="akar-icons:chevron-down"
            class="text-txprimary text-xl shrink-0 transition-transform"
            :class="{ 'rotate-180': openedIndex === index }"
          />
        </div>
        <p
          v-if="openedIndex === index"
          class="text-sm max-md:text-xs text-txprimary/60 leading-normal mt-1.5"
        >
          {{ item.answer }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  const openedIndex = ref<number | null>(null);

  const faq = [
    {
      question: "Принцип безопасной сделки",
      answer:
        "Покупка рекламы через Телепост на 100% безопасна: после того, как вы оплачиваете заказ, деньги резервируются на счету в банке и перечисляются каналу только после вашего подтверждения о выполнении заказа.",
    },
    {
      question: "Как происходит процесс покупки и размещения",
      answer:
        "Вы выбираете канал, создаете рекламный пост, указываете желаемую дату и время публикации, оплачиваете и владелец канала получает уведомление о новом заказе. Он берет в работу, публикует пост и присылает вам ссылку на него. Вы проверяете, и если все хорошо, подтверждаете выполнение заказа. После чего деньги перечисляются на баланс владельца канала.",
    },
    {
      question: "Если возникли сложности в ходе заказа",
      answer:
        "Вы всегда можете обсудить вопросы с владельцем канала в чате Телепост. А при необходимости, обратиться в поддержку прямо в своем кабинете в разделе Диалоги — мы всегда поможем.",
    },
    {
      question: "Маркировка постов",
      answer:
        "По закону, все рекламные посты должны маркироваться в ОРД. Телепост может всё сделать за вас — просто укажите реквизиты при создании поста и мы автоматически зарегистрируем пост, получим токен и отчитаемся после публикации. С вашей стороны больше ничего не потребуется.",
    },
  ];
</script>
